// extracted by mini-css-extract-plugin
export default {"root":"root--SPdH3","error":"error--Gopou","selected":"selected--PkZm4","badge":"badge--bveHr"};